<template>
	<article
		:id="id"
		:class="[labelClass, 'dc-post-grid-card', 'service-card']"
		v-on:click.meta.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.ctrl.stop.prevent="goToPost('cmdCtrl')"
		v-on:click.exact.stop.prevent="goToPost('click')"
	>
		<div ref="cardContentWrapper" class="card-content">
			<h6 v-if="label" class="card-suptitle">{{ label.title }}</h6>
			<h2 v-if="title" class="card-title">{{ title }}</h2>
			<dc-button :url="url" :aria-label="`Go to service: ${title}`" />
		</div>
	</article>
</template>

<script>
import Post from './Post';
export default {
	extends: Post,
};
</script>
